<template>

  <m-pay-layout>
    <v-layout justify-space-around :column="$vuetify.breakpoint.smAndDown">

      <m-pay-confirm-dialog
        :show="showConfirmationDialog"
        :title="confirmationDialog.description"
        @yes="confirmationDialog.action"
        @cancel="hideDialog"
        maxWidth="700px"
      />

      <v-flex>
        <v-card class="mb-3 mx-2">

          <v-card-text>
            <div>
              <div class="title">
                {{ user.firstName }} {{ user.lastName }}
              </div>
              <div>{{ user.email }}</div>
              <br/>
              <div>Created at
                <span class="body-2">
                  {{ formatters.dateTime(user.createdDate) }}
                </span>
                by
                <v-chip small color="primary" text-color="white">
                  <v-avatar>
                    <v-icon>account_circle</v-icon>
                  </v-avatar>
                  {{ user.createdBy }}
                </v-chip>
              </div>
              <div>Updated at
                <span class="body-2">
                  {{ formatters.dateTime(user.updatedDate) }}
                </span>
                by
                <v-chip small color="primary" text-color="white">
                  <v-avatar>
                    <v-icon>account_circle</v-icon>
                  </v-avatar>
                  {{ user.updatedBy }}
                </v-chip>
              </div>
              <div>Status
                <v-chip small :color="userStatusClasses[user.status]" text-color="white">
                  <v-avatar>
                    <v-icon>check_circle</v-icon>
                  </v-avatar>
                  {{ user.status }}
                </v-chip>
              </div>
            </div>
          </v-card-text>

        </v-card>
        <v-card class="mb-3 mx-2">

          <v-card-title>
            <span class="headline">Actions</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="user.status === 'ACTIVATED'" large flat color="secondary"
                   class="mx-2" :loading="loading"
                   :disabled="loading"
                   @click.prevent="blockUser">
              Block User
              <v-icon right dark>toggle_on</v-icon>
            </v-btn>
            <v-btn v-if="user.status === 'BLOCKED'" large flat color="secondary"
                   class="mx-2" :loading="loading"
                   :disabled="loading"
                   @click.prevent="activateUser">
              Activate User
              <v-icon right dark>toggle_off</v-icon>
            </v-btn>
            <v-btn v-if="user.status === 'BLOCKED_SELF'" large flat color="secondary"
                   class="mx-2" :loading="loading"
                   :disabled="loading"
                   @click.prevent="activateUser">
              Activate User
              <v-icon right dark>toggle_off</v-icon>
            </v-btn>
            <v-btn v-if="user.status === 'NOT_ACTIVATED'" large flat color="secondary"
                   class="mx-2" :loading="loading"
                   :disabled="loading"
                   @click.prevent="resendInvitation">
              Send invitation email
              <v-icon right dark>email</v-icon>
            </v-btn>
            <v-btn v-if="isAdmin == true && user.id != myUser.id"
                   large flat color="secondary"
                   class="mx-2" :loading="loading"
                   :disabled="loading"
                   @click.prevent="deleteEmployee">
              Delete
              <v-icon right dark>email</v-icon>
            </v-btn>
            <v-btn
                   v-if="user.userRole === 'MERCHANT_ADMIN'
                      && isAdmin == true" large flat color="secondary"
                   class="mx-2" :loading="loading"
                   :disabled="loading"
                   @click.prevent="setRoleOperator(user)">
              Revoke MERCHANT_ADMIN role
              <v-icon right dark>email</v-icon>
            </v-btn>
            <v-btn
                v-if="user.userRole === 'MERCHANT_OPERATOR'
                    && isAdmin == true" large flat color="secondary"
                   class="mx-2" :loading="loading"
                   :disabled="loading"
                   @click.prevent="setRoleAdmin(user)">
              Grant MERCHANT_ADMIN role
              <v-icon right dark>email</v-icon>
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="mb-3 mx-2">

          <v-card-title>
            <span class="headline">Update User</span>
          </v-card-title>

          <m-pay-user-details-editor
            :user="user"
            :loading="loading"
            @submit="updateUser"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </m-pay-layout>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayUserDetailsEditor from '../MPayUserDetailsEditor';
import MPayConfirmDialog from '../MPayConfirmDialog';
import { userStatusClasses } from '../../utils/statuses';
import formatters from '../../utils/formatters';

export default {
  name: 'MPayEmployeeUpdateView',

  components: {
    MPayUserDetailsEditor,
    MPayConfirmDialog,
  },

  data: () => ({
    user: {},
    myUser: {},
    isAdmin: false,
    loading: false,
    showConfirmationDialog: false,
    confirmationDialog: {
      action: () => {
      },
      title: '',
      description: '',
    },
    userStatusClasses,
    formatters,
  }),

  methods: {
    fetchUser() {
      if (this.$route.query.created) {
        this.showSuccessMessage('User successfully created');
        this.$router.replace({ name: 'user', params: { userId: this.$route.params.userId } });
      } else {
        this.loading = true;
        axios.get(queries.user(this.$route.params.userId))
          .then((response) => {
            this.user = response.data;
            this.loading = false;
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      }
    },
    fetchMyUser() {
      this.loading = true;
      axios.get(queries.myUser())
        .then((response) => {
          this.myUser = response.data;
          this.isAdmin = this.myUser.userRole === 'MERCHANT_ADMIN';
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    updateUser(user) {
      this.loading = true;
      /* eslint-disable no-param-reassign */
      user.id = this.user.id;
      axios.put(queries.user(this.user.id), user)
        .then(() => {
          this.loading = false;
          this.showSuccessMessage('User successfully updated.');
          this.fetchUser();
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    blockUser() {
      this.showDialog(`Block ${this.user.firstName} ${this.user.lastName}?`, () => {
        this.hideDialog();
        this.loading = true;
        axios.put(queries.userAction(this.user.id, 'block'))
          .then(() => {
            this.loading = false;
            this.showSuccessMessage('User was blocked successfully.');
            this.fetchUser();
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      });
    },
    activateUser() {
      this.showDialog(`Activate ${this.user.firstName} ${this.user.lastName}?`, () => {
        this.hideDialog();
        this.loading = true;
        axios.put(queries.userAction(this.user.id, 'activate'))
          .then(() => {
            this.loading = false;
            this.showSuccessMessage('User was activated successfully.');
            this.fetchUser();
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      });
    },
    resendInvitation() {
      this.showDialog(`Send invitation email to ${this.user.firstName} ${this.user.lastName}?`, () => {
        this.hideDialog();
        this.loading = true;
        axios.put(queries.userAction(this.user.id, 'resendInvitation'))
          .then(() => {
            this.loading = false;
            this.showSuccessMessage('Invitation was sent successfully.');
            this.fetchUser();
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      });
    },
    deleteEmployee() {
      this.showDialog(`Delete employee ${this.user.firstName} ${this.user.lastName}?`, () => {
        this.hideDialog();
        this.loading = true;
        axios.delete(queries.userMerchantEmployeeDelete(this.user.id))
          .then(() => {
            this.loading = false;
            this.showSuccessMessage('Employee deleted successfully.');
            this.$router.push({ name: 'merchant-employees' });
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      });
    },
    setRoleOperator(user) {
      this.showDialog(`Revoke MERCHANT_ADMIN role from ${this.user.firstName} ${this.user.lastName}?`, () => {
        this.hideDialog();
        this.loading = true;
        this.user.userRole = 'MERCHANT_OPERATOR';
        axios.put(queries.employeeRole(), user)
          .then(() => {
            this.loading = false;
            this.showSuccessMessage('Role was revoked successfully.');
            this.fetchUser();
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      });
    },
    setRoleAdmin(user) {
      this.showDialog(`Grant MERCHANT_ADMIN role to ${this.user.firstName} ${this.user.lastName}?`, () => {
        this.hideDialog();
        this.loading = true;
        this.user.userRole = 'MERCHANT_ADMIN';
        axios.put(queries.employeeRole(), user)
          .then(() => {
            this.loading = false;
            this.showSuccessMessage('Role was granted successfully.');
            this.fetchUser();
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      });
    },
    showDialog(message, onSuccessCallback) {
      this.showConfirmationDialog = true;
      this.confirmationDialog = {
        title: '',
        description: message,
        action: onSuccessCallback,
      };
    },
    hideDialog() {
      this.showConfirmationDialog = false;
    },
  },

  watch: {
    $route() {
    },
  },

  mounted() {
    this.fetchUser();
    this.fetchMyUser();
  },

};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayEmployeeUpdateView.vue